/**
 * Indu Lagna — the wealth ascendant.
 *
 * Mirrors resolve_indu_lagna() in the chat handlers. Take the lord of the 9th
 * sign from the Lagna and the lord of the 9th sign from the Moon, add their
 * kalas, divide by 12, and count that remainder forward from the Moon's sign
 * (counting the Moon's sign as 1). A remainder of 0 counts as 12.
 */

const SIGNS = [
  'Aries', 'Taurus', 'Gemini', 'Cancer', 'Leo', 'Virgo',
  'Libra', 'Scorpio', 'Sagittarius', 'Capricorn', 'Aquarius', 'Pisces',
];

const SIGN_RULERS = {
  Aries: 'Mars', Taurus: 'Venus', Gemini: 'Mercury', Cancer: 'Moon',
  Leo: 'Sun', Virgo: 'Mercury', Libra: 'Venus', Scorpio: 'Mars',
  Sagittarius: 'Jupiter', Capricorn: 'Saturn', Aquarius: 'Saturn',
  Pisces: 'Jupiter',
};

// Rahu and Ketu carry no kalas and never rule a sign, so they never appear.
export const PLANET_KALAS = {
  Sun: 30, Moon: 16, Venus: 12, Jupiter: 10, Mercury: 8, Mars: 6, Saturn: 1,
};

/**
 * @returns {{sign, lordFromLagna, lordFromMoon, totalKalas, remainder}|null}
 * null when the Lagna or Moon sign is missing, so callers omit the row rather
 * than show a wrong one.
 */
export function resolveInduLagna(chartData) {
  const lagnaSign = chartData?.houses?.ascendant?.sign;
  const moonSign = chartData?.planets?.Moon?.sign;
  if (!SIGNS.includes(lagnaSign) || !SIGNS.includes(moonSign)) return null;

  // The 9th sign from a reference is 8 signs forward, counting it as 1.
  const ninthFromLagna = SIGNS[(SIGNS.indexOf(lagnaSign) + 8) % 12];
  const ninthFromMoon = SIGNS[(SIGNS.indexOf(moonSign) + 8) % 12];

  const lordFromLagna = SIGN_RULERS[ninthFromLagna];
  const lordFromMoon = SIGN_RULERS[ninthFromMoon];
  if (!PLANET_KALAS[lordFromLagna] || !PLANET_KALAS[lordFromMoon]) return null;

  const totalKalas = PLANET_KALAS[lordFromLagna] + PLANET_KALAS[lordFromMoon];
  const remainder = totalKalas % 12 || 12;
  const index = (SIGNS.indexOf(moonSign) + remainder - 1) % 12;

  return {
    sign: SIGNS[index],
    ninthFromLagna,
    lordFromLagna,
    ninthFromMoon,
    lordFromMoon,
    totalKalas,
    remainder,
  };
}

export default resolveInduLagna;
